import React, { useState, FormEvent, Fragment, useEffect } from "react";
import "./styles.css";
import { useHistory, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ReactComponent as Showpassword } from "common/assets/svg/showPassword.svg";
import { ReactComponent as Hidepassword } from "common/assets/svg/hidePassword.svg";
import DialCodePicker from "components/dialCodePicker/index";
import { SignUpData, SignUpForm } from "common/features/auth/AuthModels";
import { validateField } from "common/utils/field-validator";
import {
  clearOTPState,
  clearVerifyMobile,
  saveSignUpUser,
  verifyMobile,
} from "common/features/auth/AuthActions";
import { ReactComponent as MagilhubIcon } from "common/assets/svg/magilhub_logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import { getCountryRequest } from "common/features/auth/AuthActions";
import { requestgetOffers } from "common/features/offers/offerActions";
import { offerRequestBody } from "common/features/offers/offferModels";
import Otp from "pages/authPages/otp";
import { dialogOpen } from "common/features/navigation/navigationActions";
import PasswordError from "components/PasswordError";
export interface CountryCodeData {
  code: string;
  flag: string;
}

function InnerSignup({ onClose, visible, setGuestPopup,setloginRequestPopup }: any) {
  const dispatch = useDispatch();
  const authState = useSelector((state: RootState) => state.auth);
  const history = useHistory();
  const [partyPhone, setPartyPhone] = useState("");
  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const countryCode = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.country
  );
  let { walletId } = useParams<any>();
  const walletDetails = useSelector((state: RootState) => state.offer.offers);
  const [formErrorMessage, setFormErrorMessage] = useState<string | null>(null);
  // const [countryData, setCountryData] = useState<CountryCodeData>({
  //   code: "+91",
  //   flag: "https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg",
  // });
  const [otpPopup, setOtpPopup] = useState(false);
  const setIsOpen = (set: boolean) => {
    if (set) {
      setOtpPopup(false);
    }
  };
  const [amceConsent, setAMCEConsent] = useState( true  );
  const [showAmceConsentError, setShowAMCEConsentError] = useState( false  );

  useEffect(() => {
    let data = {
      locationId: "",
      couponId: walletId,
    } as offerRequestBody;

    walletId && dispatch(requestgetOffers(data));
  }, [walletId]);

  useEffect(() => {
    dispatch(getCountryRequest());
  }, []);
  const [countryData, setCountryData] = useState<CountryCodeData>(
    countryCode == "US"
      ? {
          code: "+1",
          flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
        }
      : {
          code: "+91",
          flag: "https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg",
        }
  );

  const SignUpFormState = useSelector(
    (state: RootState) => state.auth.signUpUser
  );

  const {
    register,
    errors,
    handleSubmit,
    control,
    getValues,
    setValue,
    watch,
    formState,
  } = useForm<SignUpForm>({
    defaultValues: {
      name: SignUpFormState ? SignUpFormState.fullName : "",
      email: SignUpFormState ? SignUpFormState.email : "",
      mobilePhone: SignUpFormState ? SignUpFormState.mobile.split("-")[1] : "",
      password: "",
      confirmPassword: "",
    },
  });
  const { isDirty, isSubmitted } = formState;
  const signUpUser = useSelector((state: RootState) => state.auth.signUpUser);

  useEffect(() => {
    dispatch(clearOTPState());
    if (SignUpFormState) {
      setCountryData({
        code: SignUpFormState.mobile.split("-")[0],
        flag: SignUpFormState.countryFlag,
      });
    }
  }, []);

  const [name, setname] = useState<string>(
    SignUpFormState ? SignUpFormState.fullName : ""
  );
  const [email, setemail] = useState<string>(
    SignUpFormState ? SignUpFormState.email : ""
  );
  const [mobile, setmobile] = useState<string>(
    (SignUpFormState && SignUpFormState.mobile.split("-")[1]) || ""
  );
  const [password, setpassword] = useState<string>("");
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [isConfirmPasswordShown, setIsConfirmPasswordShown] = useState(false);

  const handleName = (event: FormEvent<HTMLInputElement>) => {
    let name = event.currentTarget.value.replace(/[^A-Za-z ]/g, "");
    var splitted = name.split(" ");
    // console.log("Input Splitted: ", splitted);

    if (
      splitted.every((name) => {
        return name == "";
      })
    ) {
      setname("");
    } else {
      if (splitted.length > 0) {
        for (var i = 0; i < splitted.length; i++) {
          if (splitted[i].length === 1) {
            //   console.log("one Len");
            splitted[i] = splitted[i].charAt(0).toUpperCase();
          } else {
            splitted[i] =
              splitted[i].charAt(0).toUpperCase() + splitted[i].slice(1);
          }
        }
        name = splitted.join(" ");
        // console.log("Output: ", name);
        setname(name);
      }
    }
  };

  const onSubmit = (data: SignUpForm) => {
    if(formState.isSubmitted){
      if(!amceConsent){
        setShowAMCEConsentError(true)
      }else{

   
    // Save SignUp Form State

    dispatch(
      saveSignUpUser({
        email: data.email,
        fullName: name,
        mobile: countryData.code + "-" + data.mobilePhone,
        password: data.password,
        countryFlag: countryData.flag,
        walletId: walletId != null ? walletId : null,
        adultSize: 0,
        kidzSize: 0,
      })
    );
    dispatch(
      verifyMobile({
        checkUserExists: 0,
        email: data.email,
        fullName: name,
        mobilePhone: countryData.code + "-" + data.mobilePhone,
        password: data.password,
        isOrderRequest: 0,
        sendOtp: 1,
        walletId:
          walletDetails && walletDetails.length > 1
            ? walletDetails[0].id
            : null,
        isReceiveTransMsg: amceConsent ? 1 : 0,
        isRegisterUser:true
      })
    );
  }
}
  };
  useEffect(() => {
    // Mobile Number Not Already Verified
    if (
      !authState.mobileVerficationLoading &&
      !authState.mobileVerifiedSuccess &&
      formState.isSubmitted &&
      authState.otpRequired
    ) {
      setOtpPopup(true);
    }

    // Invalid
    if (
      !authState.mobileVerficationLoading &&
      !authState.mobileVerifiedSuccess &&
      formState.isSubmitted &&
      !authState.otpRequired
    ) {
      setOtpPopup(false);
      setFormErrorMessage(authState.mobileVerficationMessage);
    }
    if (
      !authState.mobileVerficationLoading &&
      authState.mobileVerifiedSuccess &&
      formState.isSubmitted &&
      walletDetails
    ) {
      dispatch(clearVerifyMobile());
      setOtpPopup(false);
      onClose(true);
    } else if (
      !authState.mobileVerficationLoading &&
      authState.mobileVerifiedSuccess &&
      formState.isSubmitted &&
      walletDetails
    ) {
      dispatch(clearVerifyMobile());
      // history.push("/signUp/success/wallet/" + walletId);
    }
  }, [authState.mobileVerficationLoading]);

  const handleChange = (e: any) => {
    setname(e.target.value);
  };

  const cartUrl = useSelector((state: RootState) => state.cart.cartURL);
  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  return (
    <Fragment>
      <Otp
      type={'signup'}
        isOpen={otpPopup}
        visible={()=>{setIsOpen(true);}}
        title={" Login to avail offer"}
        subtext={" You need to login to apply this promocode."}
        cartUrl={cartUrl}
        onSuccessSignUp={()=>{onClose(true); setloginRequestPopup(true)}}
      />

      <DialCodePicker
        showPicker={showDialCodePicker}
        setShowPicker={setShowDialCodePicker}
        setCountryData={setCountryData}
        inputValue={partyPhone}
        setIsMobile={setIsMobile}
        onlyMobile={true}
      />
      <div id="sign-up-screen" className={showDialCodePicker ? "dim" : ""}>
        <div className="signUp-prompt-logo-container">
          {/* <MagilhubIcon />
          <span className="magilhub-logo">Magilhub</span> */}
        </div>
        <form
          className="sign-up-form"
          autoComplete="off"
          onSubmit={handleSubmit(onSubmit)}
          style={{ borderTopWidth: 3, borderTopColor: "red" }}
        >
          <div className="sign-up-text-box-container">
            <label className="input-label">Name</label>
            <div className={"sign-up-text-box"}>
              <input
                type="text"
                placeholder="Enter Your Name"
                autoComplete="off"
                autoCapitalize="off"
                autoFocus={true}
                name="name"
                minLength={3}
                maxLength={20}
                value={name}
                required
                onChange={(e) => {
                  handleName(e);
                }}
                style={{ fontSize: 13 }}
              />
            </div>
            <span className="sign-up-form-error-msg">
              {errors.name && errors.name.type === "required" && (
                <span>Name Required</span>
              )}
            </span>
          </div>

          <div className="sign-up-text-box-container">
            <label className="input-label">Mobile Number</label>
            <div className={"sign-up-text-box"} id="phone-input">
              <Fragment>
                <img
                  src={countryData.flag}
                  height={"14px"}
                  width={"21px"}
                  className="flag"
                  onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                />
                <span
                  className="countryCode"
                  onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                >
                  {countryData.code}
                </span>
              </Fragment>
              <input
                minLength={10}
                maxLength={10}
                type="number"
                placeholder="Enter Mobile number"
                name="mobilePhone"
                autoComplete="off"
                ref={register(
                  validateField("name").isRequired().isValidMobileNumber().Rules
                )}
                // value={mobile}
                onChange={(e) => {
                  setmobile(e.target.value);
                }}
                style={{ fontSize: 13 }}
              />
            </div>
            <span className="sign-up-form-error-msg">
              {errors.mobilePhone && errors.mobilePhone.type === "required" && (
                <span>Mobile Number Required</span>
              )}
              {errors.mobilePhone && errors.mobilePhone.type === "pattern" && (
                <span>{errors.mobilePhone.message}</span>
              )}
            </span>
          </div>

          <div className="sign-up-text-box-container">
            <label className="input-label">Email ID</label>
            <div className={"sign-up-text-box"}>
              <input
                type="email"
                placeholder="Enter Your Email ID"
                autoComplete="off"
                autoCapitalize="off"
                name="email"
                onChange={(e) => setemail(e.target.value)}
                ref={register(
                  validateField("name").isRequired().isValidEmail().Rules
                )}
                style={{ fontSize: 13 }}
              />
            </div>
            <span className="sign-up-form-error-msg">
              {errors.email &&
                errors.email.type === "required" &&
                "Email Required"}
            </span>
            {errors.email && errors.email.type === "pattern" && (
              <span className="sign-up-form-error-msg">
                {errors.email.message}
              </span>
            )}
          </div>

          <div className="sign-up-text-box-container" style={{ marginTop: 10 }}>
            <label className="input-label">New Password</label>
            <div className={"sign-up-text-box"} id="password-input-box">
              <input
                type={isPasswordShown ? "text" : "password"}
                name="password"
                placeholder="Enter password"
                autoComplete="off"
                autoCapitalize="off"
                ref={register({
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message: "Password must be more than 8 characters long",
                  },
                  pattern: {
                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]{8,}$/,
                    message: "Password must be alphanumeric, contain at least one uppercase letter, one special character and must not have spaces",
                  },
                })}
                // ref={register(
                //   validateField("password").isRequired().isValidPassword().Rules
                // )}
                style={{ fontSize: 13 }}
              />
              {isPasswordShown ? (
                <Hidepassword
                  className="hidePasswordSVG"
                  onClick={() => {
                    setIsPasswordShown(!isPasswordShown);
                  }}
                />
              ) : (
                <Showpassword
                  className="showPasswordSVG"
                  onClick={() => {
                    setIsPasswordShown(!isPasswordShown);
                  }}
                />
              )}
            </div>
            <span className="sign-up-form-error-msg">
              {errors.password && errors.password.type === "required" && (
                <span>Password Required</span>
              )}
              {errors.password && errors.password.type === "minLength" && (
                <span>{errors.password.message}</span>
              )}
              {errors.password && errors.password.type === "pattern" && (
                <PasswordError/>
              )}
            </span>
          </div>

          <div className="sign-up-text-box-container">
            <label className="input-label">Confirm Password</label>
            <div className={"sign-up-text-box"} id="password-input-box">
              <input
                type={isConfirmPasswordShown ? "text" : "password"}
                name="confirmPassword"
                autoCapitalize="off"
                autoComplete="off"
                placeholder="Re enter password"
                ref={register(
                  validateField("confirmPassword")
                    .isRequired()
                    .matchesField(
                      watch,
                      "password",
                      "",
                      "Password does not match"
                    ).Rules
                )}
                style={{ fontSize: 13 }}
              />
              {isConfirmPasswordShown ? (
                <Hidepassword
                  className="hidePasswordSVG"
                  onClick={() => {
                    setIsConfirmPasswordShown(!isConfirmPasswordShown);
                  }}
                />
              ) : (
                <Showpassword
                  className="showPasswordSVG"
                  onClick={() => {
                    setIsConfirmPasswordShown(!isConfirmPasswordShown);
                  }}
                />
              )}
            </div>
            <span className="sign-up-form-error-msg">
              {errors.confirmPassword &&
                errors.confirmPassword.type == "required" && (
                  <span>Password Required</span>
                )}
              {errors.confirmPassword &&
                errors.confirmPassword.type == "validate" && (
                  <span>{errors.confirmPassword.message}</span>
                )}
            </span>
          </div>

          <div id="sign-up-page-links-container">
            <span
              style={{ fontSize: 10, marginTop: "16px" }}
              onClick={(data) => {
                dispatch(
                  saveSignUpUser({
                    email: email,
                    fullName: name,
                    mobile: countryData.code + "-" + mobile,
                    password: password,
                    countryFlag: countryData.flag,
                    walletId: walletId != null ? walletId : null,
                    adultSize: 0,
                    kidzSize: 0,
                  })
                );
                history.push("/terms");
                dispatch(dialogOpen(true));
              }}
            >
              By creating your account you accept to our{" "}
              <span id="terms-and-conditions-link" style={{ fontSize: 10 }}>
                Terms and conditions
              </span>
            </span>

            <div className="consent-msg-container">
                  <input
                    type="checkbox"
                    className="consent-msg-checkbox"
                    checked={amceConsent}
                    // value={}
                    onChange={(e) => {
                      setAMCEConsent(!amceConsent);
                      setShowAMCEConsentError(amceConsent ? false :true)
                    }}
                  />
                  <span className="consent-msg-text">
                  By providing your phone number, you agree to receive text message from Maghil
                  </span>
                </div>
       
                {!amceConsent && showAmceConsentError && (
              <p className="consent-error-msg">Check this to receive text message</p>
            )}

            <span className="sign-up-form-error-msg">
              {formErrorMessage ? formErrorMessage : null}
            </span>
            <button id="create-button" type="submit" onClick={() => {}}>
              {authState.mobileVerficationLoading
                ? "Verifying Mobile"
                : "Create"}
              {authState.signUpLoading ? "Signing Up" : ""}
            </button>
            <div
              id="sign-in-text"
              onClick={() => {
                visible(true);
                //setGuestPopup && setGuestPopup(true);
                setloginRequestPopup && setloginRequestPopup(true)
              }}
            >
              Already have an account?
              <span />
              &nbsp;
              <span className="sign-in-link">log in</span>
            </div>

            {/* <div className="signUp-prompt-logo-container">
              <span className="signUp-prompt-logo-text">Powered by </span>
              <div>
                <MagilhubIcon />
                <span className="magilhub-logo">Magilhub</span>
              </div>
            </div> */}
          </div>
        </form>
      </div>
    </Fragment>
  );
}

export default InnerSignup;
